import Image from 'next/image'

export default function ShopifyImage({ imageData, layout = '', ...otherProps }) {
  if (layout === 'fill') {
    return <Image layout={layout} src={imageData.url} alt={imageData.altText} {...otherProps} />
  }
  return (
    <Image
      layout={layout}
      src={imageData.url}
      width={imageData.width}
      height={imageData.height}
      alt={imageData.altText}
      {...otherProps}
    />
  )
}
